import { contentClient, Server } from '@wajeez-web/core/api-base';
import { thunkErrorHandler } from '@wajeez-web/core/utils';
import { ApiMethod } from '@wajeez-web/stores/base';

export const getContentEntityListsLookups: ApiMethod<
  { searchText?: string },
  Server.ContentEntityListLookupOutput[],
  void
> = async (data, { dispatch, rejectWithValue }) => {
  return thunkErrorHandler(
    async () => {
      const client = new Server.Server_ContentEntityLists_Client(
        undefined,
        contentClient
      );

      const response = await client.admin_ContentEntityLists_lookups_get_V1(
        data.searchText
      );

      if (response.success && response.data) {
        return response.data;
      }

      return rejectWithValue(response.errors);
    },
    dispatch,
    rejectWithValue
  );
};

export const getContentEntityListsByContentEntityId: ApiMethod<
  string,
  Server.ContentEntityListByItemOutput[],
  void
> = async (id, { dispatch, rejectWithValue }) => {
  return thunkErrorHandler(
    async () => {
      const client = new Server.Server_ContentEntityLists_Client(
        undefined,
        contentClient
      );

      const response =
        await client.admin_ContentEntityLists_byContentEntity_get_V1(id);

      if (response.success && response.data) {
        return response.data;
      }

      return rejectWithValue(response.errors);
    },
    dispatch,
    rejectWithValue
  );
};

export const getContentEntityListItems: ApiMethod<
  number,
  Server.ContentEntityOutput[],
  void
> = async (id, { dispatch, rejectWithValue }) => {
  return thunkErrorHandler(
    async () => {
      const client = new Server.Server_ContentEntityLists_Client(
        undefined,
        contentClient
      );

      const response = await client.admin_ContentEntityLists_items_get_V1(
        undefined,
        id
      );

      if (response.success && response.data) {
        return response.data;
      }

      return rejectWithValue(response.errors);
    },
    dispatch,
    rejectWithValue
  );
};

export const getContentEntityListsDatatable: ApiMethod<
  Server.ContentEntityListDatatable,
  Server.TableOfContentEntityListColumns,
  void
> = async (data, { dispatch, rejectWithValue }) => {
  return thunkErrorHandler(
    async () => {
      const client = new Server.Server_ContentEntityLists_Client(
        undefined,
        contentClient
      );

      const response = await client.admin_ContentEntityLists_datatable_post_V1(
        data
      );

      if (response.success && response.data) {
        return response.data;
      }

      return rejectWithValue(response.errors);
    },
    dispatch,
    rejectWithValue
  );
};

export const createContentEntityList: ApiMethod<
  Server.CreateContentEntityListInput,
  number,
  void
> = async (data, { dispatch, rejectWithValue }) => {
  return thunkErrorHandler(
    async () => {
      const client = new Server.Server_ContentEntityLists_Client(
        undefined,
        contentClient
      );

      const response = await client.admin_ContentEntityLists_post_V1(data);

      if (response.success && response.data) {
        return response.data;
      }

      return rejectWithValue(response.errors);
    },
    dispatch,
    rejectWithValue
  );
};

export const editContentEntityList: ApiMethod<
  Server.EditContentEntityListInput,
  number,
  void
> = async (data, { dispatch, rejectWithValue }) => {
  return thunkErrorHandler(
    async () => {
      const client = new Server.Server_ContentEntityLists_Client(
        undefined,
        contentClient
      );

      const response = await client.admin_ContentEntityLists_put_V1(data);

      if (response.success && response.data) {
        return response.data;
      }

      return rejectWithValue(response.errors);
    },
    dispatch,
    rejectWithValue
  );
};

export const getContentEntityListById: ApiMethod<
  number,
  Server.ContentEntityListOutput,
  void
> = async (id, { dispatch, rejectWithValue }) => {
  return thunkErrorHandler(
    async () => {
      const client = new Server.Server_ContentEntityLists_Client(
        undefined,
        contentClient
      );

      const response = await client.admin_ContentEntityLists_byId_get_V1(id);

      if (response.success && response.data) {
        return response.data;
      }

      return rejectWithValue(response.errors);
    },
    dispatch,
    rejectWithValue
  );
};

export const setContentEntityListsItemList: ApiMethod<
  Server.SetContentEntityItemListsInput,
  void,
  void
> = async (data, { dispatch, rejectWithValue }) => {
  return thunkErrorHandler(
    async () => {
      const client = new Server.Server_ContentEntityLists_Client(
        undefined,
        contentClient
      );

      const response =
        await client.admin_ContentEntityLists_setContentEntityLists_put_V1(
          data
        );

      if (response.success) {
        return;
      }
    },
    dispatch,
    rejectWithValue
  );
};
